import React, { useEffect, useState, useRef } from "react";
import { toast } from "react-toastify";
import axios from "axios";
import { BaseUrl } from "../../../Container/BaseUrl/BaseUrl";
import { connect } from "react-redux";
import {
  GetAllUsers,
  setExternalChatData,
} from "../../../Redux/Actions/actions";
import { Button, Grid } from "@mui/material";
import { toaststyle } from "../../../Utils/toaststyle";

const mapStateToProps = (state) => {
  const { contactListData } = state;
  return {
    externalChatData: contactListData.externalChatData,
  };
};

const UserDetails2 = (props) => {
  const { editUser, setEditUser } = props;
  const userinput = useRef(null);
  const [editemail, seteditemail] = useState();
  const [editusername, seteditusername] = useState();
  const [editlasName, seteditlasName] = useState();
  const [editmobile, seteditmobile] = useState();
  const [editwhatsapp, seteditwhatsapp] = useState();
  const [editfacebook, seteditfacebook] = useState();
  const [edittwitter, setedittwitter] = useState();
  const [editteams, seteditteams] = useState();
  const [editcompany, seteditcompany] = useState();
  const [editAddress, seteditAddress] = useState();
  const [editCity, seteditCity] = useState();
  const [editpostalcode, setpostalcode] = useState();
  const [editCountry, seteditCountry] = useState();
  const [editstate, seteditstate] = useState();
  const [editType, seteditType] = useState();
  const [editLanguage, seteditLanguage] = useState();

  const updateEditvalue = async () => {
    const loggedInAgent = JSON.parse(localStorage.getItem("tokenAgent"));
    let body = {
      language: editLanguage,
      Lastname: editlasName,
      address: editAddress,
      city: editCity,
      company: editcompany,
      country: editCountry,
      email: editemail,
      facebookId: editfacebook,
      id: props.externalChatData ? props.externalChatData.unique_id.id : "",
      type: editType,
      phonenumber: editmobile,
      postalcode: editpostalcode,
      state: editstate,
      teamsId: editteams,
      twitterId: edittwitter,
      username: editusername,
      whatsappnumber: editwhatsapp,
      agent_id: loggedInAgent.id,
      chat_session_id: props.externalChatData
        ? props.externalChatData.chat_session_id
        : "",
    };

    axios
      .post(BaseUrl + "/users/updateClient", body, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
          "Content-Type": "application/json",
          tenantId: localStorage.getItem("TenantId"),
        },
      })
      .then((res) => {
        console.log("externalchatdata", res.data.session[0]);
        if (res.data.status) {
          props.GetAllUsers();
          props.setExternalChatData("");
          toast.success("Client Updated Successfully", toaststyle);
          setEditUser(true);
        } else {
          toast.error(res.data.message, toaststyle);
          props.setExternalChatData("");
          setEditUser(true);
        }
      })
      .catch((error) => {
        console.log("error", error);
      });
  };
  const updateCurrentValue = () => {
    seteditusername(
      props.externalChatData
        ? props.externalChatData.unique_id
          ? props.externalChatData.unique_id.username
          : "NA"
        : "NA"
    );
    seteditemail(
      props.externalChatData
        ? props.externalChatData.unique_id
          ? props.externalChatData.unique_id.email
          : "NA"
        : "NA"
    );
    seteditwhatsapp(
      props.externalChatData
        ? props.externalChatData.unique_id
          ? props.externalChatData.unique_id.whatsappnumber
          : "NA"
        : "NA"
    );
    seteditmobile(
      props.externalChatData ? props.externalChatData.phonenumber : "NA"
    );
    seteditfacebook(
      props.externalChatData
        ? props.externalChatData.unique_id
          ? props.externalChatData.unique_id.facebookId
          : "NA"
        : "NA"
    );
    setedittwitter(
      props.externalChatData
        ? props.externalChatData.unique_id
          ? props.externalChatData.unique_id.twitterId
          : "NA"
        : "NA"
    );
    seteditteams(
      props.externalChatData
        ? props.externalChatData.unique_id
          ? props.externalChatData.unique_id.teamsId
          : "NA"
        : "NA"
    );
    seteditcompany(
      props.externalChatData
        ? props.externalChatData.unique_id
          ? props.externalChatData.unique_id.company
          : "NA"
        : "NA"
    );
    setpostalcode(
      props.externalChatData
        ? props.externalChatData.unique_id
          ? props.externalChatData.unique_id.address
          : "NA"
        : "NA"
    );
    seteditType(
      props.externalChatData
        ? props.externalChatData.unique_id
          ? props.externalChatData.unique_id.Type
          : "NA"
        : "NA"
    );
    seteditCountry(
      props.externalChatData
        ? props.externalChatData.unique_id
          ? props.externalChatData.unique_id.country
          : "NA"
        : "NA"
    );
    seteditstate(
      props.externalChatData
        ? props.externalChatData.unique_id
          ? props.externalChatData.unique_id.state
          : "NA"
        : "NA"
    );
    seteditLanguage(
      props.externalChatData
        ? props.externalChatData.unique_id
          ? props.externalChatData.unique_id.Language
          : "NA"
        : "NA"
    );
    seteditCity(
      props.externalChatData
        ? props.externalChatData.unique_id
          ? props.externalChatData.unique_id.city
          : "NA"
        : "NA"
    );
    seteditlasName(
      props.externalChatData
        ? props.externalChatData.unique_id
          ? props.externalChatData.unique_id.Lastname
          : "NA"
        : "NA"
    );
    seteditAddress(
      props.externalChatData
        ? props.externalChatData.unique_id
          ? props.externalChatData.unique_id.address
          : "NA"
        : "NA"
    );
  };
  useEffect(() => {
    updateCurrentValue();
  }, [props.externalChatData]);

  return (
    <Grid container className="overflow-auto" spacing={0.6}>
      <Grid item md={3} sm={3}>
        <div
          className="d-flex flex-column text-start"
          style={{
            fontSize: "11px",
            fontWeight: 600,
            userSelect: "none",
            color: "#0d407ebf",
          }}
        >
          <label>First Name</label>
          <input
            disableElevation
            type="text"
            ref={userinput}
            customer-details
            value={editusername}
            disabled={editUser}
            onChange={(e) => seteditusername(e.target.value)}
            className="form-control form-select-sm customer-details"
          />
        </div>
      </Grid>
      <Grid item md={3} sm={3}>
        <div
          className="d-flex flex-column text-start"
          style={{
            fontSize: "11px",
            fontWeight: 600,
            userSelect: "none",
            color: "#0d407ebf",
          }}
        >
          <label>Last Name</label>
          <input
            type="text"
            value={editlasName}
            disabled={editUser}
            className="form-control form-select-sm customer-details"
            onChange={(e) => seteditlasName(e.target.value)}
          />
        </div>
      </Grid>
      <Grid item md={3} sm={3}>
        <div
          className=" d-flex flex-column text-start"
          style={{
            fontSize: "11px",
            fontWeight: 600,
            userSelect: "none",
            color: "#0d407ebf",
          }}
        >
          <label>Type</label>
          <input
            type="text"
            disabled={editUser}
            value={editType}
            className="form-control form-select-sm customer-details"
            onChange={(e) => seteditType(e.target.value)}
          />
        </div>
      </Grid>
      <Grid item md={3} sm={3}>
        <div
          className=" d-flex flex-column text-start"
          style={{
            fontSize: "11px",
            fontWeight: 600,
            userSelect: "none",
            color: "#0d407ebf",
          }}
        >
          <label>Phone</label>
          <input
            type="text"
            disabled={editUser}
            value={editmobile}
            className="form-control form-select-sm customer-details"
            onChange={(e) => seteditmobile(e.target.value.replace(/[^\d]/, ""))}
          />
        </div>
      </Grid>
      <Grid item md={3} sm={3}>
        <div
          className=" d-flex flex-column text-start"
          style={{
            fontSize: "11px",
            fontWeight: 600,
            userSelect: "none",
            color: "#0d407ebf",
          }}
        >
          <label>Email</label>
          <input
            type="email"
            disabled={editUser}
            value={editemail}
            className="form-control form-select-sm customer-details"
            onChange={(e) => seteditemail(e.target.value)}
          />
        </div>
      </Grid>
      <Grid item md={3} sm={3}>
        <div
          className=" d-flex flex-column text-start"
          style={{
            fontSize: "11px",
            fontWeight: 600,
            userSelect: "none",
            color: "#0d407ebf",
          }}
        >
          <label>Language</label>
          <input
            type="text"
            disabled={editUser}
            value={editLanguage}
            className="form-control form-select-sm customer-details"
            onChange={(e) => seteditLanguage(e.target.value)}
          />
        </div>
      </Grid>
      <Grid item md={3} sm={3}>
        <div
          className=" d-flex flex-column text-start"
          style={{
            fontSize: "11px",
            fontWeight: 600,
            userSelect: "none",
            color: "#0d407ebf",
          }}
        >
          <label>Company</label>
          <input
            type="text"
            value={editcompany}
            disabled={editUser}
            onChange={(e) => seteditcompany(e.target.value)}
            className="form-control form-select-sm customer-details"
          />
        </div>
      </Grid>
      <Grid item md={3} sm={3}>
        <div
          className=" d-flex flex-column text-start"
          style={{
            fontSize: "11px",
            fontWeight: 600,
            userSelect: "none",
            color: "#0d407ebf",
          }}
        >
          <label>City</label>
          <input
            type="text"
            disabled={editUser}
            value={editCity}
            className="form-control form-select-sm customer-details"
            onChange={(e) => seteditCity(e.target.value)}
          />
        </div>
      </Grid>
      <Grid item md={3} sm={3}>
        <div
          className=" d-flex flex-column text-start"
          style={{
            fontSize: "11px",
            fontWeight: 600,
            userSelect: "none",
            color: "#0d407ebf",
          }}
        >
          <label>State</label>
          <input
            type="text"
            disabled={editUser}
            value={editstate}
            className="form-control form-select-sm customer-details"
            onChange={(e) => seteditstate(e.target.value)}
          />
        </div>
      </Grid>
      <Grid item md={3} sm={3}>
        <div
          className=" d-flex flex-column text-start"
          style={{
            fontSize: "11px",
            fontWeight: 600,
            userSelect: "none",
            color: "#0d407ebf",
          }}
        >
          <label>Postal code</label>
          <input
            type="text"
            disabled={editUser}
            value={editpostalcode}
            className="form-control form-select-sm customer-details"
            onChange={(e) => setpostalcode(e.target.value)}
          />
        </div>
      </Grid>
      <Grid item md={3} sm={3}>
        <div
          className="d-flex flex-column text-start"
          style={{
            fontSize: "11px",
            fontWeight: 600,
            userSelect: "none",
            color: "#0d407ebf",
          }}
        >
          <label>Country</label>
          <input
            type="text"
            disabled={editUser}
            value={editCountry}
            className="form-control form-select-sm customer-details"
            onChange={(e) => seteditCountry(e.target.value)}
          />
        </div>
      </Grid>
      <Grid item md={3} sm={3}>
        <div
          className="d-flex"
          style={{
            gap: "5px",
            alignItems: "center",
            justifyContent: "center",
            height: "100%",
            marginTop: "10px",
          }}
        >
          {!editUser && (
            <>
              <Button
                disableElevation
                variant="contained"
                size="small"
                onClick={() => {
                  updateEditvalue();
                }}
                sx={{
                  textTransform: "capitalize",
                  fontSize: "10px",
                  padding: "2px",
                }}
              >
                Submit
              </Button>
              <Button
                disableElevation
                variant="outlined"
                size="small"
                onClick={() => {
                  setEditUser(true);
                }}
                sx={{
                  textTransform: "capitalize",
                  fontSize: "10px",
                  padding: "2px",
                }}
              >
                Cancel
              </Button>
            </>
          )}
          {editUser && (
            <Button
              variant="outlined"
              size="small"
              onClick={() => {
                setEditUser(false);
                setTimeout(() => {
                  userinput.current.focus();
                }, 0);
              }}
              sx={{
                textTransform: "capitalize",
                fontSize: "10px",
                padding: "2px",
                width: "120px",
              }}
            >
              Edit Customer
            </Button>
          )}
        </div>
      </Grid>
    </Grid>
  );
};

export default connect(mapStateToProps, {
  GetAllUsers,
  setExternalChatData,
})(UserDetails2);
